import { api } from './client';
import type { SchemaResponse } from './types';

export function getSchema() {
  return api.get<SchemaResponse>('/api/admin/schema');
}
